import { PositionedQuestionClusterRequest, QuestionClusterDto } from './questionClusterTypes';
import { Positioned } from './positionedTypes';

export interface BaseModule {
  id: number,
  title?: string,
  description?: string,
}

export interface QuestionModuleDto extends BaseModule {
  clusters: QuestionClusterDto[],
  position: number
}

export interface QuestionModuleRequest {
  title?: string,
  description?: string,
  clusters: PositionedQuestionClusterRequest[]
}

export interface PositionedQuestionModuleRequest extends Positioned {
  questionModule: QuestionModuleDto
}

export function emptyQuestionModuleRequest(): QuestionModuleRequest {
  return {
    title: '',
    description: '',
    clusters: []
  }
}
